import React from 'react';

export const HallEditor = React.lazy(() => import('./HallEditor').then((module) => ({default: module.HallEditor})))
